import React from 'react';
import { Flex } from '@chakra-ui/react';
import CheckLists from '../CheckLists';
import { ICOCConfig } from '@publishing-engine/domain/models';

interface CheckListsTabProps {
  journalId: string;
  journalName: string;
  cocConfig?: ICOCConfig[];
}

const CheckListsTab: React.FC<CheckListsTabProps> = ({ journalId }) => {
  return (
    <Flex flexDirection="column" gap={4} width="100%">
      <CheckLists journalId={journalId} />
    </Flex>
  );
};

export default React.memo(CheckListsTab);
